import { createContext } from "react";
import type { CreatedOrder } from "@/lib/projects";

export type NewProjectCreatedHandler = (order: CreatedOrder) => void;

/** Vorauswahl aus der Projektliste (Ordner- bzw. S-Ordner-Filter). */
export type NewProjectOrdnerPrefill =
  | { type: "projekt"; ordnerNummer: string; jahr?: number | null; kunde?: string }
  | { type: "s"; sordnerNummer: string };

/** Formular-Vorbelegung (z. B. aus Tagesgeschäft-Mail-Analyse). */
export interface NewProjectFormPrefill {
  beschreibung?: string | null;
  ortZusatz?: string | null;
  /** Freitext – wird als Kontakt-Label gesetzt, wenn kein Hero-Match. */
  ansprechpartner?: string | null;
  ansprechpartnerEmail?: string | null;
  /** Freitext-Adresse als Hinweis im Ort-Zusatz / Adress-Suche. */
  adresse?: string | null;
}

export interface NewProjectContextValue {
  /** Öffnet den Dialog. Optional: One-shot-Callback nach erfolgreichem Anlegen. */
  open: (options?: {
    onCreated?: NewProjectCreatedHandler;
    ordnerPrefill?: NewProjectOrdnerPrefill;
    formPrefill?: NewProjectFormPrefill;
    /** z. B. Tagesgeschäft: Beauftragung läuft separat, Nachfrage unterdrücken. */
    skipAskCommissionAfterCreate?: boolean;
  }) => void;
  /** Schließt den Dialog. */
  close: () => void;
  /** Aktueller Öffnungszustand. */
  isOpen: boolean;
  /** Registriert einen langlebigen Listener für neu angelegte Projekte. */
  subscribe: (listener: NewProjectCreatedHandler) => () => void;
}

export const NewProjectContext = createContext<NewProjectContextValue | null>(null);
